import React from 'react';

const PencilIcon = ({ fill = '#0B45B3', size = 15 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.6687 3.85919C12.6742 3.36965 12.4841 2.89818 12.1406 2.54933C11.7913 2.20391 11.3219 2.00705 10.8307 2.00002C10.348 1.99791 9.88434 2.18793 9.54199 2.52818L12.1406 5.14791C12.4892 4.81114 12.6807 4.34372 12.6687 3.85919Z" fill={fill}/>
        <path d="M11.5488 5.73919L8.9502 3.14062L2.92911 9.16171L5.52768 11.7603L11.5488 5.73919Z" fill={fill} />
        <path d="M2.59157 10.0073L2 12.6904L4.6831 12.0989L2.59157 10.0073Z" fill={fill}/>
    </svg>
  );
};

export default PencilIcon;